import "../scss/blog.scss";
import { $Q, $Qll } from "../utils/query-selector";
import { Ajaxinate } from 'ajaxinate'

const initBlog = () => new Ajaxinate({
  container: '#AjaxinateContainer',
  pagination: '#AjaxinatePagination',
  offset: 400,
  loadingText: ``,
});

const initFilter = () => {
  const filter = $Q('.blog__filer-control');
  const filterButtons = $Qll('.blog__filer-control', filter);

  if (!filter || !filterButtons.length) return;

  filterButtons.forEach((item) => {
    const link = $Q('.blog__filter-link', item);
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const { target } = e;
      const { href } = target;
      window.location.href = href;
    });
  });
};

const hideClassicNavigation = () => {
  const classicNavigation = $Q('.blog-section .pagination');

  if (classicNavigation) classicNavigation.setAttribute('hidden', '')
}

initBlog()

initFilter()

hideClassicNavigation()
